import React, { memo } from 'react';
import PropTypes from 'prop-types';
import DateTimeField from './DateTimeField';
import { NO_STATE } from '../../hooks/useExtendedState';
import { extendedStateType } from '../../types';

DateField.propTypes = {
    label: PropTypes.node,
    value: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string,
    ]),
    inputId: PropTypes.string,
    onChange: PropTypes.func,
    validator: PropTypes.func,
    onValidated: PropTypes.func,
    className: PropTypes.string,
    invalidBefore: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string,
    ]),
    onReset: PropTypes.func,
    isChanged: PropTypes.bool,
    isRequired: PropTypes.bool,
    dateFormat: PropTypes.string,
    isValidDate: PropTypes.func,
    initialViewDate: PropTypes.instanceOf(Date),
    state: extendedStateType,
    validateOnValidatorChange: PropTypes.bool,
};

DateField.defaultProps = {
    onChange: undefined,
    value: undefined,
    validator: null,
    onValidated: undefined,
    inputId: null,
    className: '',
    invalidBefore: null,
    onReset: undefined,
    isChanged: undefined,
    isRequired: false,
    label: null,
    dateFormat: 'DD.MM.YYYY',
    isValidDate: null,
    initialViewDate: null,
    state: NO_STATE,
    validateOnValidatorChange: false,
};

export const DAY_AND_MONTH = 'DD.MM.';
export const YEAR = 'YYYY';

function DateField(props) {
    const {
        label,
        inputId,
        value,
        onChange,
        className,
        validator,
        onValidated,
        invalidBefore,
        onReset,
        isChanged,
        isRequired,
        dateFormat,
        isValidDate,
        initialViewDate,
        state,
        validateOnValidatorChange,
    } = props;
    return (
        <DateTimeField
            label={label}
            inputId={inputId}
            value={value}
            onChange={onChange}
            className={className}
            validator={validator}
            onValidated={onValidated}
            invalidBefore={invalidBefore}
            onReset={onReset}
            isChanged={isChanged}
            isRequired={isRequired}
            timeFormat={false}
            dateFormat={dateFormat}
            isValidDate={isValidDate}
            initialViewDate={initialViewDate}
            state={state}
            validateOnValidatorChange={validateOnValidatorChange}
        />
    );
}

export default memo(DateField);
